import { Box, CircularProgress, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { apiVariable } from "../../../api/apiVariable";
import { assignedTrucksTableColumns } from "../../../data/FormColumns/Fleet/assignedTrucksTableColumns";

const fetchAssignedTrucks = async (
  token: string | null | undefined,
  trailerId: string,
) => {
  const { data } = await axios.get(
    `${apiVariable}/getAssignedTruckHistoryOnTrailer/${trailerId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return data;
};

interface AssignedTrucksProps {
  trailerId: string;
  token: string | null | undefined;
}

const AssignedTrucks = ({ trailerId, token }: AssignedTrucksProps) => {
  const {
    data: assignedTrucks,
    isLoading: isLoadingTrucks,
    isError: isErrorTrucks,
    error: truckError,
  } = useQuery({
    queryKey: ["assignedTrucks", trailerId],
    queryFn: () => fetchAssignedTrucks(token, trailerId),
    enabled: !!trailerId,
  });

  if (isLoadingTrucks) {
    return <CircularProgress />;
  }

  if (isErrorTrucks) {
    return (
      <Typography color="error">
        Error: {(truckError as Error).message}
      </Typography>
    );
  }

  return (
    <Box sx={{ height: 400, width: { xs: "100%", sm: "80%" }, minWidth: 0 }}>
      <DataGrid
        rows={assignedTrucks || []}
        columns={assignedTrucksTableColumns}
      />
    </Box>
  );
};

export default AssignedTrucks;
